import React from 'react';

function TabContent({
  tabValue,
  currValue,
  children,
}: {
  tabValue: any;
  currValue: any;
  children: React.ReactNode;
}) {
  if (tabValue === currValue) {
    return <>{children}</>;
  } else {
    return null;
  }
}
export default TabContent;
